import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles: () => Record<string, string> = makeStyles((theme: Theme) => ({
  mobileDrawer: {
    width: 256,
    top: 84,
    height: 'calc(100% - 84px)',
  },
  desktopDrawer: {
    width: 206,
    top: 84,
    height: 'calc(100% - 64px)',
  },
  navBarContainer: {
    backgroundColor: theme.palette.background.main,
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64,
  },
  logo: {
    maxWidth: '300px',
    maxHeight: '100px',
  },
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
  },
  buttonLeaf: {
    color: theme.palette.text.secondary,
    // on hover change text and icon color
    '&:hover': {
      color: theme.palette.action.active,
      opacity: 0.8,
    },
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      '& $title': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  title: {
    marginRight: 'auto',
    fontSize: theme.typography.h4.fontSize,
  },
  active: {
    color: theme.palette.action.active,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& $icon': {
      color: theme.palette.action.active,
    },
  },
  yearSelectorContainer: {
    padding: theme.spacing(2, 2, 0, 2),
  },
  yearLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  yearIcon: {
    fontSize: '1rem',
  },
  yearSelect: {
    width: '100%',
    '& .MuiSelect-select': {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

export default useStyles;
